import { injectable } from 'inversify';
import Mime from 'mime/lite';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { EditorSession } from '../../canvas/EditorSession';
import { ContentPayload } from '../../canvas/injection/ContentPayload';
import { ContentProcessor } from '../../canvas/injection/ContentProcessor';
import { resolve } from '../../Container';
import { PopupManager } from '../../popups/PopupManager';

// Windows, if Excel is installed, reports CSV files as this mime type: application/vnd.ms-excel
// Who knows right?  Anyway we need to swap it to being CSV if its a text file, thanks MS.

@injectable()
export class StupidWinExcelCsvFixDataProcessor implements ContentProcessor {

    @resolve(CommandDispatcher) dispatch!: CommandDispatcher;
    @resolve(EditorSession) session!: EditorSession;
    @resolve(ObjectManager) objects!: ObjectManager;
    @resolve(PopupManager) popups!: PopupManager;

    public readonly supportedTypes = Object.freeze([
        'application/vnd.ms-excel'
    ]);

    public async process(payload: ContentPayload): Promise<boolean | ContentPayload> {

        // Try read text
        const textData = await payload.getDataAsText();
        if (!textData) return false;

        // If text, convert to correct mime type
        return ContentPayload.derive(payload, Mime.getType('csv'), payload.data);
    }
}
